import React from 'react';

import { AssetDetailReport, AreaDetailReport, AlertDashboardReport, AllAssetsReport, EventSummaryReport, SiteReport, EventNotesReport, AllChecklistReport, ChecklistSummaryReport, AssetComparisonReport, CorrectiveActionReport, ReportSectionContainer, ChecklistPassiveTempReport, ChecklistComplianceReport, ChecklistPhotoReport, ChecklistDataDownload, ChecklistScheduleAdherenceReport } from '../Reporting';
import { MonitoringAlertDetail, MonitoringLocations, MonitoringLocationDetail, AlertList, CompletedChecklists, CompletedChecklistDetail } from '../MonitoringAlerts';
import { EventConfigurations, EventConfigurationView, EventConfigurationAdd, EventConfigurationEdit, EventWorkflowConfigurationView, EventWorkflowConfigurationAdd, EventWorkflowConfigurationEdit } from "../EventConfiguration";
import { Actions, ActionView, ActionAdd, ActionEdit } from '../Action';
import { Assets, AssetView, AssetAdd, AssetEdit } from '../Assets';
import { AssetTypes, AssetTypeView, AssetTypeAdd, AssetTypeEdit } from '../AssetTypes';
import { Thresholds, ThresholdView, ThresholdAdd, ThresholdEdit } from '../Threshold';
import { Tickets, TicketView } from '../Ticket';
import { Groups } from '../Group';
import { Tags, TagView, TagEdit, TagAdd } from '../Tag';
import { Groupings, GroupingView, GroupingAdd, GroupingEdit, GroupingFloorPlan } from '../Grouping';
import { Roles, RoleView, RoleEdit, RoleAdd } from '../Role';
import { Devices, DeviceView, DeviceEdit, DeviceEditGroupMetadata, DeviceViewGroupMetadata, DevicesBulkEdit } from '../Device';
import { DeviceRegistrations, DeviceRegistrationView, DeviceRegistrationAdd } from '../Registration';
import { Users, UserView, UserEdit, UserAdd, UserProfile } from '../User';
import { NotificationPreferences } from '../User/NotificationPreference';
import { Checklists, ChecklistView, ChecklistAdd, ChecklistEdit } from '../Checklist';
import { Dashboard } from '../Dashboard';
import { HelpDetail, HelpListing } from '../Help';
import MonitorChecklistDetail from '../MonitoringAlerts/monitor_checklist_detail';
import { ChecklistUsers, ChecklistUserAdd, ChecklistUserEdit, ChecklistUserView } from '../ChecklistUser';
import { ScheduledReports } from '../ScheduledReports';
import { Audits } from '../Audits';
import { APIKeys, APIList } from '../API';

const EventsResolutionReport = props => <div><div className="row"><div className="op-page-header"><div className="op-page-header__left"><h2 className="op-page-header__title">Events Resolution</h2></div></div></div><center><img style={{ maxWidth: '1024px' }} src="images/events_resolution_report.png" /></center></div>;
const EventsByGroupReport = props => <div><div className="row"><div className="op-page-header"><div className="op-page-header__left"><h2 className="op-page-header__title">Events by Group</h2></div></div></div><center><img style={{ maxWidth: '1024px' }} src="images/events_by_group_report.png" /></center></div>;
const AlertCountReport = props => <div><div className="row"><div className="op-page-header"><div className="op-page-header__left"><h2 className="op-page-header__title">Event Count by Type</h2></div></div></div><center><img style={{ maxWidth: '1024px' }} src="images/alert_count_by_type_report.png " /></center></div>;
const ThresholdRangeReport = props => <div><div className="row"><div className="op-page-header"><div className="op-page-header__left"><h2 className="op-page-header__title">Threshold and Range</h2></div></div></div><center><img style={{ maxWidth: '1024px' }} src="images/threshold_range_report.png" /></center></div>;
const HACCPExceptionReport = props => <div><div className="row"><div className="op-page-header"><div className="op-page-header__left"><h2 className="op-page-header__title">HACCP Exception Report</h2></div></div></div><center><img style={{ maxWidth: '1024px' }} src="images/haccp-exception-report.png" /></center></div>;

const PATH_TO_COMPONENTS = {
  '/monitoring/locations': MonitoringLocations,
  '/monitoring/locations/:deviceGroupingId/:tab': MonitoringLocationDetail,
  '/monitoring/locations/:deviceGroupingId/events/:eventId': MonitoringAlertDetail,
  '/monitoring/locations/:deviceGroupingId/checklists/:checklistId': MonitorChecklistDetail,
  '/monitoring/dashboard': Dashboard,
  '/monitoring/dashboard/events': AlertList,
  '/monitoring/dashboard/events/:eventId': MonitoringAlertDetail,
  '/monitoring/checklists': CompletedChecklists,
  '/monitoring/checklists/:completedChecklistId': CompletedChecklistDetail,
  '/monitoring/tickets': Tickets,
  '/monitoring/tickets/view/:ticketId': TicketView,
  '/user/profile': UserProfile,
  '/user/profile/notifications': NotificationPreferences,
  '/config/events': EventConfigurations,
  '/config/events/view/:eventConfigurationId': EventConfigurationView,
  '/config/events/edit/:eventConfigurationId': EventConfigurationEdit,
  '/config/events/add': EventConfigurationAdd,
  '/config/events/workflows/view/:eventConfigurationId': EventWorkflowConfigurationView,
  '/config/events/workflows/edit/:eventConfigurationId': EventWorkflowConfigurationEdit,
  '/config/events/workflows/add': EventWorkflowConfigurationAdd,  
  '/config/actions': Actions,
  '/config/actions/view/:actionId': ActionView,
  '/config/actions/edit/:actionId': ActionEdit,
  '/config/actions/add': ActionAdd,
  '/config/devices': Devices,
  '/config/devices/bulk-edit': DevicesBulkEdit,
  '/config/devices/view/:deviceId': DeviceView,
  '/config/devices/edit/:deviceId': DeviceEdit,
  '/config/devices/:deviceId/amtedit/:amtId': DeviceEditGroupMetadata,
  '/config/devices/:deviceId/amtview/:amtId': DeviceViewGroupMetadata,
  '/config/assets': Assets,
  '/config/assets/add': AssetAdd,
  '/config/assets/view/:assetId': AssetView,
  '/config/assets/edit/:assetId': AssetEdit,
  '/config/registrations': DeviceRegistrations,
  '/config/registrations/view/:deviceRegistrationId': DeviceRegistrationView,
  '/config/registrations/add': DeviceRegistrationAdd,
  '/config/thresholds': Thresholds,
  '/config/thresholds/view/:thresholdId': ThresholdView,
  '/config/thresholds/edit/:thresholdId': ThresholdEdit,
  '/config/thresholds/add': ThresholdAdd,
  '/config/checklists': Checklists,
  '/config/checklists/add': ChecklistAdd,
  '/config/checklists/edit/:checklistId': ChecklistEdit,
  '/config/checklists/view/:checklistId': ChecklistView,
  '/config/checklist/users': ChecklistUsers,
  '/config/checklist/users/add': ChecklistUserAdd,
  '/config/checklist/users/edit/:checklistUserId': ChecklistUserEdit,
  '/config/checklist/users/view/:checklistUserId': ChecklistUserView,
  '/admin/api': APIList,
  '/admin/api/tokens': APIKeys,
  '/admin/audit': Audits,
  '/admin/asset-types': AssetTypes,
  '/admin/asset-types/add': AssetTypeAdd,
  '/admin/asset-types/view/:assetTypeId': AssetTypeView,
  '/admin/asset-types/edit/:assetTypeId': AssetTypeEdit,  
  '/admin/groupings': Groupings,
  '/admin/groupings/view/:deviceGroupingId': GroupingView,
  '/admin/groupings/edit/:deviceGroupingId': GroupingEdit,
  '/admin/groupings/add': GroupingAdd,
  '/admin/groupings/:deviceGroupingId/floor-plan': GroupingFloorPlan,
  '/admin/users': Users,
  '/admin/users/add': UserAdd,
  '/admin/users/view/:userId': UserView,
  '/admin/users/edit/:userId': UserEdit,
  '/admin/groups': Groups,
  '/admin/tags': Tags,
  '/admin/tags/add': TagAdd,
  '/admin/tags/view/:tagId': TagView,
  '/admin/tags/edit/:tagId': TagEdit,
  '/admin/roles': Roles,
  '/admin/roles/view/:roleId': RoleView,
  '/admin/roles/edit/:roleId': RoleEdit,
  '/admin/roles/add': RoleAdd,
  '/admin/scheduled-reports': ScheduledReports,
  '/reporting/assets': ReportSectionContainer,
  '/reporting/assets/asset-detail': AssetDetailReport,
  '/reporting/assets/all-assets': AllAssetsReport,
  '/reporting/assets/area-detail': AreaDetailReport,
  '/reporting/assets/site': SiteReport,
  '/reporting/assets/asset-comparison': AssetComparisonReport,
  '/reporting/events': ReportSectionContainer,
  '/reporting/events/events-resolution': EventsResolutionReport,
  '/reporting/events/events-by-group': EventsByGroupReport,
  '/reporting/events/event-count': AlertCountReport,
  '/reporting/events/threshold-range': ThresholdRangeReport,
  '/reporting/events/haccp-exceptions': HACCPExceptionReport,
  '/reporting/events/event-dashboard': AlertDashboardReport,
  '/reporting/events/event-summary': EventSummaryReport,
  '/reporting/events/event-notes': EventNotesReport,
  '/reporting/checklists': ReportSectionContainer,
  '/reporting/checklists/checklist-summary': ChecklistSummaryReport,
  '/reporting/checklists/corrective-actions': CorrectiveActionReport,
  '/reporting/checklists/all-checklist': AllChecklistReport,
  '/reporting/checklists/passive-temp-checklist': ChecklistPassiveTempReport,
  '/reporting/checklists/checklist-compliance-report': ChecklistComplianceReport,
  '/reporting/checklists/checklist-photo-report': ChecklistPhotoReport,
  '/reporting/checklists/checklist-data-download': ChecklistDataDownload,
  '/reporting/checklists/checklist-schedule-adherence-report': ChecklistScheduleAdherenceReport,
  '/help': HelpListing,
  '/help/:slug': HelpDetail
};

// download-report-icon.svg, summary-report-icon.svg, single-report-icon.svg
const REPORT_ROUTE_REMAP = [{
    route: {id: 100001, children: [], path: '/reporting/assets', priority: 1, showOnMenu: true, title: "Assets"},
    paths: {
      '/reporting/asset-detail': { title: 'Asset Detail', icon: 'summary-report-icon.svg' },
      '/reporting/all-assets': { title: 'All Assets', icon: 'summary-report-icon.svg' },
      '/reporting/area-detail': { title: 'Area Detail', icon: 'single-report-icon.svg' },
      '/reporting/site': { title: 'Site Detail', icon: 'single-report-icon.svg' },
      '/reporting/asset-comparison': { title: 'Asset Comparison', icon: 'single-report-icon.svg' }
    }
  }, {
    route: {id: 100002, children: [], path: '/reporting/events', priority: 2, showOnMenu: true, title: "Events"},
    paths: {
      '/reporting/events-resolution': { title: 'Event Resolution', icon: 'summary-report-icon.svg' },
      '/reporting/events-by-group': { title: 'Events By Group', icon: 'summary-report-icon.svg' },
      '/reporting/event-count': { title: 'Event Count', icon: 'single-report-icon.svg' },
      '/reporting/threshold-range': { title: 'Threshold Range', icon: 'single-report-icon.svg' },
      '/reporting/haccp-exceptions': { title: 'HACCP Exceptions', icon: 'single-report-icon.svg' },
      '/reporting/event-dashboard': { title: 'Event Dashboard', icon: 'single-report-icon.svg' },
      '/reporting/event-summary': { title: 'Event Summary', icon: 'summary-report-icon.svg' },
      '/reporting/event-notes': { title: 'Event Notes', icon: 'single-report-icon.svg' }
    }
  }, {
    route: {id: 100003, children: [], path: '/reporting/checklists', priority: 3, showOnMenu: true, title: "Checklists"},
    paths: {
      '/reporting/checklist-summary': { title: 'Checklist Summary', icon: 'summary-report-icon.svg' },
      '/reporting/corrective-actions': { title: 'Corrective Actions', icon: 'single-report-icon.svg' },
      '/reporting/all-checklist': { title: 'All Checklists', icon: 'single-report-icon.svg' },
      '/reporting/passive-temp-checklist': { title: 'Passive Temperature', icon: 'single-report-icon.svg' },
      '/reporting/checklist-compliance-report': { title: 'Compliance', icon: 'summary-report-icon.svg' },
      '/reporting/checklist-photo-report': { title: 'Photos', icon: 'summary-report-icon.svg' },
      '/reporting/checklist-data-download': { title: 'Data Download', icon: 'download-report-icon.svg' },
      '/reporting/checklist-schedule-adherence-report': { title: 'Schedule Adherence', icon: 'summary-report-icon.svg' },
    }
  }
];

export {
  PATH_TO_COMPONENTS,
  REPORT_ROUTE_REMAP
};
